import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'psc-home-calculator',
  templateUrl: './home-calculator.component.html'
})
export class HomeCalculatorComponent implements OnInit {
  source: string | null = null;

  constructor(
    private activatedRoute: ActivatedRoute,
  ) {
  }

  ngOnInit(): void {
    this.source = this.activatedRoute.snapshot.queryParamMap.get('source');
  }

}
